import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedAdminRoute = ({ isAdmin,setIsAdmin, component: Component}) => {
    // console.log(isAuthenticated)
    return isAdmin ? <Component isAdmin={isAdmin} setIsAdmin={setIsAdmin} /> : <Navigate to="/SignIn" />;
};

export default ProtectedAdminRoute;